import React, { Component, PropTypes } from 'react';
import { FileService } from '../../../../services/fileUpload/uploadFile';
import { connect } from 'react-redux';
import { without } from 'lodash';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'sabre-spark-react';
import Promise from 'bluebird';
import ReactSparkTextInput from '../../ReactSparkTextInput';
import './FileTransportXHR2.scss';

const MAX_FILESIZE = 5242880; //5MB
class FileTransportXHR2 extends Component {
    static propTypes = {
        onProgress: PropTypes.func,
        onUploadStart: PropTypes.func,
        onError: PropTypes.func,
        onSuccess: PropTypes.func,
        onComplete: PropTypes.func,
        metadata: PropTypes.object,
        multiple: PropTypes.bool
    };
    static defaultProps = {
        metadata: {},
        filter: '.*',
        multiple: true
    };
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            fileProgress: [],
            totalProgress: 0.0,
            filesExist: [],
            renameValidation: true,
            confirmOverrideModalOpened: false,
            filename: ''
        };
        this.doUpload = this.doUpload.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onError = this.onError.bind(this);
        this.setFilename = this.setFilename.bind(this);
        this.onResetErrors = this.onResetErrors.bind(this);
    }

    progressHandler() {
        if (this.props.onProgress) {
            this.props.onProgress(this.state.totalProgress);
        }
    }

    setFilename(name) {
        this.setState((prevState, props) => {
            return { filename: name };
        });
    }
    /*shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextState.files, this.state.files) && false;
    }*/

    componentDidMount() {
        if (this.props.setImplementation) {
            this.props.setImplementation(this);
        }
    }
    onComplete() {
        if (this.props.onComplete) {
            this.props.onComplete();
        }
        this.onRefresh();
        this.setState({ files: [] });
        this.filesExists();
    }
    onSuccess(result) {
        if (this.props.onSuccess) {
            this.props.onSuccess(result);
        }
    }
    filesExistsDialogChoice(action, file) {
        const filesToAsk = without(this.state.filesExist, file);

        this.setState((prevState, props) => {
            file.override = action === 'overwrite';
            this.onResetErrors();

            if (action === 'rename') {
                file.rename = this.getRenameValue(file.name, this.state.filename);
            }
            if (action === 'rename' && (!this.state.filename || this.state.filename.trim() === '')) {
                return {
                    renameValidation: false
                };
            }
            if (action === 'rename' || action === 'overwrite') {
                const acc = [...prevState.files, file];
                if (filesToAsk.length === 0) {
                    this.doUpload({ target: { files: acc } });
                }
                return {
                    files: acc,
                    filesExist: filesToAsk,
                    filename: '',
                    renameValidation: true
                };
            }

            return {
                filename: '',
                filesExist: filesToAsk,
                renameValidation: true
            };
        });
    }
    getRenameValue(existingFilename, newFilename) {
        if (!newFilename) {
            return '';
        }

        if (newFilename.indexOf('.') !== -1) {
            return newFilename;
        } else {
            if (!existingFilename) {
                return newFilename;
            }

            const ext = existingFilename.split('.').pop();
            return `${newFilename}.${ext}`;
        }
    }
    filesExists(close, files) {
        if (this.state.filesExist.length && !close) {
            this.setState({ confirmOverrideModalOpened: true });
        } else {
            this.setState({ confirmOverrideModalOpened: false });
        }
    }
    onOpen() {
        this.filesRef.value = '';
        this.props.onOpen && this.props.onOpen();
    }
    onRefresh() {
        this.props.onRefresh && this.props.onRefresh();
    }
    onResetErrors() {
        this.props.onResetErrors && this.props.onResetErrors();
    }
    onError(errors, next) {
        //TODO: change needed on service side to provide some sort of more meaningful error code? Using description temporarly
        if (!Array.isArray(errors) && error) {
            errors = [error];
        }
        const existingFiles = [];
        errors.forEach(error => {
            if (error.message === 'The file already exists') {
                existingFiles.push(error.file);
            }
            if (this.props.onError) {
                this.props.onError(error);
            }
        });
        if (existingFiles) {
            this.setState((prevState, props) => {
                return {
                    filesExist: [...prevState.filesExist, ...existingFiles]
                };
            }, next);
        } else {
            if (typeof next === 'function') {
                next();
            }
        }
        this.onRefresh();
    }
    doUpload(event) {
        const inputFiles = [...event.target.files];
        this.setState({
            totalProgress: 0
        });
        this.progressHandler();
        if (this.props.onUploadStart) {
            this.props.onUploadStart();
        }
        let regexp = new RegExp(this.props.filter, 'i');
        let errors = [];
        let files = inputFiles
            .filter(file => {
                let extensionCheck = regexp.test(file.name);
                if (!extensionCheck) {
                    errors.push({
                        title: 'File type not allowed',
                        message: `File type of ${file.name} does not match ${this.props.filter}`
                    });
                }
                return extensionCheck;
            })
            .filter(file => {
                let fileSizeCheck = file.size <= MAX_FILESIZE;
                if (!fileSizeCheck) {
                    errors.push({
                        title: 'Max allowed file size is 5MB',
                        message: `File size of ${file.name} is over 5MB`
                    });
                }
                return fileSizeCheck;
            })
            .filter(file => {
                let existsCheck =
                    !file.override && this.props.assets.find(asset => asset.filename === (file.rename || file.name));
                if (existsCheck) {
                    errors.push({
                        title: `File ${file.name} already exists`,
                        message: `The file already exists`,
                        file: file
                    });
                }
                return !existsCheck;
            });

        if (errors.length) {
            this.onError(errors, () => {
                if (!files.length) {
                    this.onComplete();
                }
            });
        } else if (!files.length) {
            this.onComplete();
        }
        if (!files.length) {
            return;
        }
        const { chainId, hotelId, level } = this.props;
        let totalSize = files.reduce((totalSize, file) => totalSize + file.size, 0);
        if (!this.props.metadata.fontfamily) {
            this.props.metadata.fontfamily = undefined;
        }
        this.setState({
            files: files.map(file =>
                Object.assign(
                    file,
                    { weight: Math.max(1.0, file.size) / totalSize },
                    {
                        metadata: Object.assign({}, this.props.metadata)
                    }
                )
            ),
            fileProgress: files.map(file => 0.0)
        });
        let config = i => ({
            onUploadProgress: progressEvent => {
                let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
                let progressUpdate = [...this.state.fileProgress];
                progressUpdate[i] = this.state.files[i].weight * percentCompleted;
                this.setState({
                    fileProgress: progressUpdate,
                    totalProgress: Math.round(progressUpdate.reduce((progressItem, acc) => acc + progressItem, 0))
                });
                this.progressHandler();
            }
        });
        return Promise.all(
            files.map((file, i) => {
                return FileService.upload(chainId, hotelId, level, file, config(i), this.props.metadata).then(
                    this.onSuccess,
                    this.onError
                );
            })
        ).finally(this.onComplete);
    }

    render() {
        const fileExist = this.state.filesExist[0] || {};
        return (
            <div>
                <input
                    style={{ display: 'none' }}
                    type="file"
                    name="files"
                    multiple={this.props.multiple}
                    ref={node => (this.filesRef = node)}
                    onChange={e => this.doUpload(e)}
                />
                <button
                    className="spark-btn spark-btn--sm align-middle"
                    disabled={this.props.disabled}
                    type="button"
                    onClick={() => {
                        this.onOpen();
                        this.filesRef.click();
                    }}
                >
                    UPLOAD
                </button>
                <Modal
                    isOpen={this.state.filesExist.length > 0 && this.state.confirmOverrideModalOpened}
                    onClose={() => {
                        this.filesExistsDialogChoice('no', fileExist);
                    }}
                >
                    <ModalHeader>
                        <h3>File {fileExist.name} already exists.</h3>
                    </ModalHeader>
                    <ModalBody>
                        <p>Would you like to overwrite?</p>
                        <p>
                            {!this.state.renameValidation && (
                                <div className="spark-message spark-message--error">
                                    <i className="spark-message__icon spark-icon-ban spark-icon--fill"></i>
                                    <p className="spark-message__content">
                                        <b>In order to rename please fill the name filed</b>
                                    </p>
                                </div>
                            )}
                            <ReactSparkTextInput
                                value={this.state.filename}
                                onChange={e => this.setFilename(e.target.value)}
                                label="or rename it"
                            />
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <nav className="spark-btn-group">
                            <button
                                className="spark-btn spark-btn--md spark-btn--secondary spark-btn-group-secondary"
                                onClick={() => {
                                    this.filesExistsDialogChoice('no', fileExist);
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className="spark-btn spark-btn--md spark-btn-group-primary"
                                onClick={() => {
                                    this.filesExistsDialogChoice('rename', fileExist);
                                }}
                            >
                                Yes, rename
                            </button>
                            <button
                                className="spark-btn spark-btn--md spark-btn-group-primary"
                                onClick={() => {
                                    this.filesExistsDialogChoice('overwrite', fileExist);
                                }}
                            >
                                Yes, overwrite
                            </button>
                        </nav>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        assets: state.app.selected.assets
    };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FileTransportXHR2);



// WEBPACK FOOTER //
// ./src/components/widgets/FileTransportProxy/adapter/FileTransportXHR2.js